import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Phone = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M14.594 13.994l-1.66 1.66c-.577-.109-1.734-.471-2.926-1.66-1.193-1.193-1.553-2.354-1.661-2.926l1.661-1.66.701-.701-5.414-5.414-.701.701-1 1a.991.991 0 0 0-.291.649c-.015.25-.302 6.172 4.291 10.766C11.6 20.414 16.618 20.707 18 20.707c.202 0 .326-.006.358-.008a.994.994 0 0 0 .649-.291l1-1 .697-.697-5.414-5.414-.696.697z", key: "k0" })));
});
Phone.displayName = 'Phone';
export var PhoneDimensions = { height: 24, width: 24 };
